/**
 * This file is auto-generated from ChatMultiSelectInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const submitButton: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Continue';
        case 'pl':
            return 'Kontynuuj';
    }
};

export const selectOption: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Select at least one option';
        case 'pl':
            return 'Wybierz przynajmniej jedną opcję';
    }
};
